import React, { useState, useEffect } from 'react';
import ImageLightbox from './ImageLightbox';
import faibar1 from '../assets/faibar/WhatsApp Image 2026-04-07 at 10.48.19 AM(1).jpeg';
import faibar2 from '../assets/faibar/WhatsApp Image 2026-04-09 at 5.23.42 PM (1)(1).jpeg';
import faibar3 from '../assets/faibar/WhatsApp Image 2026-04-09 at 5.23.42 PM (2)(1).png';
import faibar4 from '../assets/faibar/WhatsApp Image 2026-04-09 at 5.23.42 PM(1).jpeg';
import faibar5 from '../assets/faibar/WhatsApp Image 2026-04-09 at 5.23.43 PM(1).png';
import faibar6 from '../assets/faibar/WhatsApp Image 2026-04-09 at 5.23.47 PM (1)(1).png';
import faibar7 from '../assets/faibar/WhatsApp Image 2026-04-09 at 5.23.47 PM(1).png';
import faibar8 from '../assets/faibar/WhatsApp Image 2026-04-09 at 5.23.50 PM (1)(1).png';

const PremiumCollections = () => {
  const [scrollSpeed, setScrollSpeed] = useState(1);
  const [lightbox, setLightbox] = useState(null);
  
  useEffect(() => {
    const handleVisibilityChange = () => {
      setScrollSpeed(document.hidden ? 0 : 1);
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  const products = [
    {
      id: 1,
      title: "Luxury Living Room Set",
      category: "Living Room",
      image: faibar1,
      price: "Starting from ₹2,999"
    },
    {
      id: 2,
      title: "Modern Bedroom Collection",
      category: "Bedroom",
      image: faibar2,
      price: "Starting from ₹1,999"
    },
    {
      id: 3,
      title: "Executive Office Suite",
      category: "Office",
      image: faibar3,
      price: "Starting from ₹3,499"
    },
    {
      id: 4,
      title: "Elegant Dining Ensemble",
      category: "Dining",
      image: faibar4,
      price: "Starting from ₹1,799"
    },
    {
      id: 5,
      title: "Contemporary Kitchen Design",
      category: "Kitchen",
      image: faibar5,
      price: "Starting from ₹4,999"
    },
    {
      id: 6,
      title: "Spa Bathroom Collection",
      category: "Bathroom",
      image: faibar6,
      price: "Starting from ₹2,499"
    },
    {
      id: 7,
      title: "Minimalist Study Room",
      category: "Study",
      image: faibar7,
      price: "Starting from ₹1,299"
    },
    {
      id: 8,
      title: "Luxury Walk-in Closet",
      category: "Storage",
      image: faibar8,
      price: "Starting from ₹3,299"
    }
  ];

  return (
    <section className="py-16 sm:py-20 md:py-24 bg-gradient-to-br from-amber-50 via-white to-amber-50 w-full">
      {/* Full Width Container */}
      <div className="w-full">
        {/* Section Header - Full Width */}
        <div className="text-center mb-12 sm:mb-16 px-4 sm:px-6 md:px-8 lg:px-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Premium Collections
          </h2>
          <p className="text-base sm:text-lg md:text-xl max-w-4xl mx-auto text-gray-600">
            Discover our curated selection of luxury interior design products, 
            crafted to transform your space into a masterpiece
          </p>
        </div>

        {/* Full Width Single Row Marquee Container */}
        <div className="relative overflow-hidden w-full">
          {/* Gradient Overlays for Smooth Edges */}
          <div className="absolute left-0 top-0 bottom-0 w-20 sm:w-32 bg-gradient-to-r from-amber-50 to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-20 sm:w-32 bg-gradient-to-l from-amber-50 to-transparent z-10"></div>
          
          {/* Single Row Marquee Track - Full Width */}
          <div className="relative w-full">
            {/* Single Marquee Row - Only One Row */}
            <div
              className="flex space-x-6 premium-marquee-track"
              style={{
                animation: `premium-marquee ${25 / scrollSpeed}s linear infinite`,
              }}
            >
              {products.map((product) => (
                <div
                  key={product.id}
                  className="flex-shrink-0 w-72 sm:w-80 bg-white rounded-2xl border border-amber-200 shadow-lg overflow-hidden group hover:border-amber-500 transition-all duration-300 hover:scale-105 hover:shadow-2xl"
                >
                  {/* Product Image */}
                  <div
                    role="button"
                    tabIndex={0}
                    className="relative h-48 overflow-hidden cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-inset"
                    onClick={(e) => {
                      e.stopPropagation();
                      setLightbox({ src: product.image, alt: product.title });
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        e.stopPropagation();
                        setLightbox({ src: product.image, alt: product.title });
                      }
                    }}
                  >
                    <img
                      src={product.image}
                      alt={product.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 pointer-events-none"
                    />
                  </div>
                  
                  {/* Title Below Image */}
                  <div className="p-4 text-center">
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 group-hover:text-amber-600 transition-colors">
                      {product.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Additional Features - Full Width */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mt-16 px-4 sm:px-6 md:px-8 lg:px-16">
          <div className="text-center p-6 bg-white rounded-2xl border border-amber-200 shadow-lg">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="material-symbols-outlined text-white text-2xl">local_shipping</span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Free Delivery</h3>
            <p className="text-gray-600 text-sm">On orders above ₹5,000</p>
          </div>
          
          <div className="text-center p-6 bg-white rounded-2xl border border-amber-200 shadow-lg">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="material-symbols-outlined text-white text-2xl">handyman</span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Expert Installation</h3>
            <p className="text-gray-600 text-sm">Professional setup service</p>
          </div>
          
          <div className="text-center p-6 bg-white rounded-2xl border border-amber-200 shadow-lg">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="material-symbols-outlined text-white text-2xl">verified</span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">5 Year Warranty</h3>
            <p className="text-gray-600 text-sm">Quality guarantee on all products</p>
          </div>
        </div>
      </div>

      <ImageLightbox
        isOpen={!!lightbox}
        src={lightbox?.src ?? null}
        alt={lightbox?.alt ?? ''}
        onClose={() => setLightbox(null)}
      />
    </section>
  );
};

export default PremiumCollections;
